import type { SuggestionStatus } from './types';

export type VoteState = 'voted' | 'can-vote' | 'locked';

export interface DeriveVoteStateInput {
  status: SuggestionStatus;
  viewerHasVoted: boolean;
  pending: boolean;
}

/**
 * Casting a new vote requires `public`; withdrawing one is allowed at any
 * status, so promoting a suggestion never strands a vote somebody wants back.
 */
export function deriveVoteState({ status, viewerHasVoted, pending }: DeriveVoteStateInput): VoteState {
  if (pending) return 'locked';
  if (viewerHasVoted) return 'voted';
  return status === 'public' ? 'can-vote' : 'locked';
}
